import React, { useEffect, useRef } from "react";
import { SITE_KEY_INVISIBLE } from "../../../keys";
import config from "../../../config/ConfigApplication";

const RecaptchaInvisible = ({ token, change, error }) => {
	const recaptchaRef = useRef(null);

	useEffect(() => {
		if (!config.enableCaptcha) return token({ "Recaptcha-Token": {} });

		const script = document.createElement("script");
		script.src = "https://www.google.com/recaptcha/enterprise.js";
		script.async = true;
		script.defer = true;

		script.onload = () => {
			window.grecaptcha.enterprise.ready(() => {
				window.onSuccess = onSuccess;
				window.onExpired = onExpired;
				window.recaptchaError = recaptchaError;

				window.grecaptcha.enterprise.render(recaptchaRef.current, {
					sitekey: config.siteKeyRecaptcha || SITE_KEY_INVISIBLE,
					size: "invisible",
					callback: "onSuccess",
					"expired-callback": "onExpired",
					"error-callback": "recaptchaError",
				});

				executeRecaptcha();
			});
		};

		document.head.appendChild(script);
	}, []);

	const executeRecaptcha = () => {
		window.grecaptcha.enterprise.execute();
	};

	const onExpired = () => {
		window.grecaptcha.enterprise.reset();
	};

	const recaptchaError = () => {
		error(true);
	};

	const onSuccess = (RecaptchaToken) => {
		token({ "Recaptcha-Token": RecaptchaToken });
		change(Boolean(String(RecaptchaToken).length));
	};

	return <div ref={recaptchaRef} />;
};

export default RecaptchaInvisible;
